/* unplugin-vue-components disabled */import { render } from "./SearchPopup.vue?vue&type=template&id=64fa0236&scoped=true"
import script from "./SearchPopup.vue?vue&type=script&lang=js"
export * from "./SearchPopup.vue?vue&type=script&lang=js"

import "./SearchPopup.vue?vue&type=style&index=0&id=64fa0236&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa0236"]])

export default __exports__